import { ProductGridTileFragment } from '@lib/graphql/graphql'
import { selectCountry } from '@redux/globalSlice'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

type Recommendations = any[] // Change 'any' to the actual type of recommendation data

export type ServingConfig =
  | 'default_search'
  | 'others_that_you_may_like'
  | 'recently_viewed_default'
  | 'recommended_for_you'
  | 'similar_items'

export type EventType =
  | 'add-to-cart'
  | 'detail-page-view'
  | 'home-page-view'
  | 'purchase-complete'
  | 'search-page-view'
  | 'shopping-cart-page-view'
  | 'category-page-view'

export type ProductIdList = {
  product: {
    id: string
  }
}[]

const useRecommendations = (options: {
  mixProducts?: boolean
  fetchRecommendations?: boolean
  servingConfig: ServingConfig
  eventType: EventType
  pageSize?: number
  products?: ProductGridTileFragment[]
}): [Recommendations | [], { loading: boolean }] => {
  const [loading, setLoading] = useState<boolean>(true)
  const [recommendations, setRecommendations] =
    useState<Recommendations | null>(null)
  const country = useSelector(selectCountry)
  // Function to fetch the recommendations
  const fetchRecommendations = async () => {
    try {
      // Call your Next.js API handler here
      const response = await fetch('/api/google-recom', {
        method: 'POST',

        body: JSON.stringify({
          servingConfig: options.servingConfig,
          eventType: options.eventType,
          pageSize: options.pageSize,
          products: options.products ?? [],
          country: country?.code,
        }), // Send the selected servingConfig to the API
      })
      const data = await response.json()
      setRecommendations(data)
      setLoading(false) // Set loading to false after the data is fetched
    } catch (error) {
      console.error('Error fetching recommendations:', error)
      setLoading(false) // Set loading to false even on error
    }
  }

  // Fetch the recommendations on component mount (you can call this function wherever you need it)
  useEffect(() => {
    if (!options.fetchRecommendations) return
    fetchRecommendations()
  }, [options.fetchRecommendations])

  if (!recommendations?.length) return [null, { loading }]
  // make recommendations with heroVariant.soldOnline == true show before products with heroVariant.soldOnline == false

  recommendations?.sort((a, b) => {
    if (a.heroVariant?.soldOnline && !b.heroVariant?.soldOnline) {
      return -1
    } else if (!a.heroVariant?.soldOnline && b.heroVariant?.soldOnline) {
      return 1
    } else {
      return 0
    }
  })

  const mixedProducts =
    options.mixProducts && recommendations
      ? [...options.products, ...recommendations]
      : []
  const uniqueProducts = new Set(
    options.mixProducts ? mixedProducts : recommendations || [],
  )

  if (!options.fetchRecommendations) return [null, { loading: false }]

  return [Array.from(uniqueProducts), { loading }]
}

export default useRecommendations
